export enum TagType {
  MemberPortalUserNotifications = 'MemberPortalUserNotifications',
  MemberPortalUserNotificationsCount = 'MemberPortalUserNotificationsCount',
  MemberPortalAllergiesDictionary = 'MemberPortalAllergiesDictionary',
  UserNotifications = 'UserNotifications',
  UserNotificationsCount = 'UserNotificationsCount',
  CorporationGeneralInfo = 'CorporationGeneralInfo',
  ClubGeneralInfoView = 'ClubGeneralInfoView',
  ClubIntegrations = 'ClubIntegrations',
  BookingEvents = 'BookingEvents',
  BookingEvent = 'BookingEvent',
  PeakFeeProcessingInfo = 'PeakFeeProcessingInfo',
  PeakRemittances = 'PeakRemittances',
  CorporationRoles = 'CorporationRoles',
  CorporationPolicies = 'CorporationPolicies',
  ClientAdjustments = 'ClientAdjustments',
  RecurringClientAdjustments = 'RecurringClientAdjustments',
  AdjustmentCategories = 'AdjustmentCategories',
  Reconciliation = 'Reconciliation',
  PeakClientAdjustments = 'PeakClientAdjustments',
  PeakRecurringClientAdjustments = 'PeakRecurringClientAdjustments',
}
